/* Rudie Journal — table of contents + share helpers */
(function () {
  function bindCopy(btn) {
    if (btn.dataset.jInit) return; btn.dataset.jInit = '1';
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url') || window.location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url);
        var o = btn.textContent; btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = o; }, 1500);
      }
    });
  }

  function initTOC(content) {
    if (content.dataset.jInit) return; content.dataset.jInit = '1';
    var body = content.querySelector('.journal-body');
    var list = content.querySelector('.journal-toc__list');
    var toc = content.querySelector('.journal-toc');
    var grid = content.querySelector('.journal-content__grid');
    if (!body || !list) return;
    var hs = body.querySelectorAll('h2');
    if (!hs.length) {
      if (toc) toc.style.display = 'none';
      if (grid) grid.classList.add('journal-content__grid--solo');
      return;
    }
    var links = [];
    hs.forEach(function (h, i) {
      var id = h.id || 'jsec-' + (i + 1); h.id = id;
      var n = (i + 1 < 10 ? '0' : '') + (i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      var numEl = document.createElement('span'); numEl.className = 'num'; numEl.textContent = n;
      var txtEl = document.createElement('span'); txtEl.textContent = h.textContent;
      a.appendChild(numEl); a.appendChild(txtEl);
      li.appendChild(a); list.appendChild(li); links.push(a);
    });
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var id = e.target.id;
            links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + id); });
          }
        });
      }, { rootMargin: '-90px 0px -70% 0px' });
      hs.forEach(function (h) { obs.observe(h); });
    }
  }

  function boot() {
    document.querySelectorAll('.journal-copy').forEach(bindCopy);
    document.querySelectorAll('.journal-content').forEach(initTOC);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
